import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";
import commonStyles from "../../../../styles/common.module.css";
import { useTranslation } from "react-i18next";
interface SelectComponentProps {
  label: string;
  options: { value: string; label: string }[];
  selectedValue: string;
  onChange: (value: string) => void;
}

const SelectComponent: React.FC<SelectComponentProps> = ({
  label,
  options,
  selectedValue,
  onChange,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:960px)");
  const {t,i18n} = useTranslation();
  return (
    <FormControl
      sx={{
        width: isSmallScreen ? "280px" :"360px",
      }}
    >
      <Select
        value={selectedValue}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--color-primary)",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--color-primary)",
          },
          textAlign: "left",
          fontWeight:700
        }}
        MenuProps={{
          disableScrollLock: true,
          sx: {
            zIndex: 9999,
          },
        }}
      >
        <MenuItem disabled value="">
          {label}
        </MenuItem>
        {[...options]
        .sort((a,b)=>(i18n.getFixedT("en")(a.label)).localeCompare(i18n.getFixedT("en")(b.label)))
        .map((option) => (
          <MenuItem key={t(`${option.value}`)} value={option.value}>
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectComponent;
